// extracted by mini-css-extract-plugin
export default {"overlay":"qC-z","bodyOpen":"rC-z","content":"sC-z","header":"tC-z","closeNoHeading":"uC-z"};